import { SwitchField, TextField } from "components/form/fields";
import { Column, Row, Section } from "components/layout";

import { ListField } from "../components";
import { TEXTS } from "../constants";
import { VARIANT_FIELDS } from "../fields";
import { VariantForm } from "../types";

export function TiVoAppFormUriTransformTab() {
  return (
    <Section header={TEXTS.URI_TRANSFORM.HEADER}>
      <Row>
        <Column>
          <SwitchField {...VARIANT_FIELDS.URI_TRANSFORM.ENABLED} />
        </Column>
      </Row>
      <Row>
        <Column>
          <TextField {...VARIANT_FIELDS.URI_TRANSFORM.ALT_PLAYBACK_URI} />
        </Column>
        <Column>
          <TextField {...VARIANT_FIELDS.URI_TRANSFORM.CLASS_NAME} />
        </Column>
      </Row>
      <Row>
        <Column>
          <ListField<
            NonNullable<
              VariantForm["uriTransform"]["providerSpecificNameValueMap"]
            >[number]
          >
            {...VARIANT_FIELDS.URI_TRANSFORM.NAME_VALUE_MAP}
            template={{ name: "", value: "" }}
            draggable
          >
            {({ name, ...field }) => (
              <Row>
                <Column>
                  <TextField
                    {...field}
                    name={`${name}.name`}
                    look="simple"
                    placeholder={TEXTS.URI_TRANSFORM.NAME_PLACEHOLDER}
                  />
                </Column>
                <Column>
                  <TextField
                    {...field}
                    name={`${name}.value`}
                    look="simple"
                    placeholder={TEXTS.URI_TRANSFORM.VALUE_PLACEHOLDER}
                  />
                </Column>
              </Row>
            )}
          </ListField>
        </Column>
      </Row>
    </Section>
  );
}
